import { useLocale } from "react-admin";
import { ProLogsLocale } from "./localization";

const localeMap = {
  en: "en-US",
  es: "es-ES",
  fr: "fr-FR",
  sr: "sr-Latn",
};

const useDefaultLocale = () => {
  const locale = useLocale() as ProLogsLocale;
  const dateFnsLocale = !!localeMap[locale] ? localeMap[locale] : "en-US";
  return dateFnsLocale;
};

export default useDefaultLocale;
